import { useQuery } from '@tanstack/react-query';

import { Badge } from '../../components/ui/Badge.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { inventoryApi } from '../../services/inventoryApi.js';
import { formatCurrency, formatDateTime, formatNumber } from '../../utils/formatters.js';

export function ConsignmentDetailModal({ consignmentId, onClose }) {
  const { t } = useTranslation();
  const detail = useQuery({ queryKey: ['inventory', 'consignment', consignmentId], queryFn: () => inventoryApi.getConsignment(consignmentId).then((r) => r.items), enabled: Boolean(consignmentId) });
  const c = detail.data;

  return (
    <Modal open={Boolean(consignmentId)} onClose={onClose}
      title={c ? `${c.productSku} · ${c.supplierName}` : t('cons.detail.title')}
      footer={<Button variant="ghost" onClick={onClose}>{t('common.close')}</Button>}>
      {c && (
        <div className="form-stack">
          <p className="muted text-sm">{c.productName} · {c.warehouseCode} · {t('cons.col.quantity')}: <strong>{formatNumber(c.quantity)}</strong> · {t('cons.col.value')}: <strong>{formatCurrency(c.value)}</strong></p>
          <div className="settings-divider">{t('cons.movements')}</div>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr><th>{t('cons.mv.type')}</th><th className="num">{t('cons.col.quantity')}</th><th className="num">{t('cons.col.value')}</th><th>{t('cons.mv.time')}</th></tr>
              </thead>
              <tbody>
                {(c.movements || []).map((m) => (
                  <tr key={m.id}>
                    <td><Badge variant={m.type === 'RECEIPT' ? 'success' : 'warning'}>{t(`cons.mv.${m.type}`)}</Badge></td>
                    <td className="num mono">{formatNumber(m.quantity)}</td>
                    <td className="num mono">{formatCurrency(m.value)}</td>
                    <td className="muted text-sm">{formatDateTime(m.createdAt)}{m.note ? ` · ${m.note}` : ''}</td>
                  </tr>
                ))}
                {(c.movements || []).length === 0 && <tr><td colSpan={4} className="muted">{t('cons.noMovements')}</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Modal>
  );
}
